<template>
    <vx-card title="Exception Form">
        <div class="vx-row">
            <div class="vx-col w-1/4">
                <div class="vx-row mb-6 w-full">
                    <div class="vx-col sm:w-1/4 flex items-center">
                        <span>Code</span>
                    </div>
                    <div class="vx-col sm:w-3/4 w-full">
                        <vs-input class="w-full" type="text" placeholder="Auto Generated" v-model="exception"
                            readonly />
                    </div>
                </div>
                <div class="vx-row mb-6 w-full">
                    <div class="vx-col sm:w-1/4 flex items-center">
                        <span>Driver</span>
                    </div>
                    <div class="vx-col sm:w-3/4 w-full">
                        <vs-input class="w-full" type="text" v-model="driver" readonly />
                    </div>
                </div>
                <div class="vx-row mb-6 w-full">
                    <div class="vx-col sm:w-1/4 flex items-center">
                        <span>Date</span>
                    </div>
                    <div class="vx-col sm:w-3/4 w-full">
                        <vs-input class="w-full" type="text" v-model="data.date" readonly />
                    </div>
                </div>
                <div class="vx-row mb-6 w-full">
                    <div class="vx-col sm:w-1/4 flex items-center">
                        <span>Status</span>
                    </div>
                    <div class="vx-col sm:w-3/4 w-full">
                        <vs-input class="w-full" type="text" placeholder="Draft" :value="stsExcText(data.status)"
                            readonly />
                    </div>
                </div>
                <div class="vx-row w-full mt-2">
                    <div class="vx-col sm:w-1/4 flex items-center">
                        <span>Notes</span>
                    </div>
                    <div class="vx-col sm:w-3/4 w-full">
                        <vs-textarea class="w-full" v-model="data.notes" />
                    </div>
                </div>
                <div class="vx-row my-6 w-full">
                    <div class="vx-col sm:w-1/4 w-full">
                        <span>Note History</span>
                    </div>
                    <div class="vx-col sm:w-3/4 w-full">
                        <template v-for="note in history_notes">
                            <b v-bind:key="note">{{ note }}<br>
                            </b>
                        </template><br>
                    </div>
                </div>
            </div>
            <div class="vx-col w-3/4">
                <table class="vs-table vs-table--tbody-table">
                    <thead>
                        <tr>
                            <th class="text-center">Shipment</th>
                            <th class="text-center">DO/PI</th>
                            <th class="text-center">Invoice</th>
                            <th class="text-center">is COD</th>
                            <th class="text-center">POD Confirmed</th>
                            <th class="text-center">Total PI</th>
                            <th class="text-center">Total Invoice</th>
                            <th class="text-center">Collection Driver</th>
                            <th class="text-center">Total CIT/Payment Collected</th>
                            <th class="text-center">Need Exception</th>
                            <th class="text-center">Daily Closing Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(group, shipment) in groupedSummary">
                            <tr v-for="(item, index) in group" :key="shipment + '-' + index">
                                <td v-if="index === 0" :rowspan="group.length">
                                    {{ shipment }}
                                    <p>{{ "Date : " + formatDate(item.delivery_plan_date) }}</p>
                                </td>
                                <td>{{ item.do_code }}</td>
                                <td>
                                    {{ item.invoice_code }}
                                    <p v-if="item.invoice_code">{{ "Date : " + formatDate(item.invoice_date) }}</p>
                                </td>
                                <td class="text-center">{{ item.is_cod == 1 ? 'Yes' : 'No' }}</td>
                                <td class="text-center">
                                    {{ item.pod_code != '' && item.pod_code != null ? 'Yes' : 'No' }}
                                </td>
                                <td class="text-right tabular-nums">{{ formatNumber(item.pi_total) }}</td>
                                <td class="text-right tabular-nums">{{ formatNumber(item.so_total) }}</td>
                                <td class="text-right tabular-nums">{{ formatNumber(item.cit_driver) }}</td>
                                <td class="text-right tabular-nums">{{ formatNumber(item.billing_total) }}</td>
                                <td class="text-center">{{ needException(item) }}</td>
                                <td v-if="index === 0" :rowspan="group.length" class="text-center">
                                    {{ group[0].closing_status }}
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>

        <div v-if="(!this.data.id || this.data.status == 0 || this.data.status == 3) && hasException">
            <vs-divider style="width: 100%; margin-left: 0%">Attachment</vs-divider>
            <div class="vx-row mb-3 mt-6 w-4/4" style="width: 100%; margin-left: 0%">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>File</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <div class="vx-col sm:w-4/5 w-full">
                        <input id="fileInput" name="file" class="w-full inputx" type="file" ref="file"
                            accept=".jpg, .jpeg, .png, .pdf" multiple />
                    </div>
                </div>
            </div>

            <div class="vx-row mb-3 mt-6 w-4/4" style="width: 100%; margin-left: 0%">
                <div class="vx-col sm:w-1/3 w-full">
                    <span></span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <div class="vx-col sm:w-4/5 w-full">
                        <vs-button class="mr-3 mb-2" @click="handleAttachment">Add Attachment</vs-button>
                    </div>
                </div>
            </div>
        </div>

        <vs-divider style="width: 100%; margin-left: 0%">List Attachment</vs-divider>
        <div class="vx-row mb-3 mt-6 w-4/4" style="width: 100%; margin-left: 0%">
            <table class="vs-table vs-table--tbody-table">
                <template v-for="(tr, i) in data.file">
                    <tr class="tr-values vs-table--tr tr-table-state-null selected" :key="tr.id || tr.name + '-' + i">
                        <td class="td vs-table--td">{{ tr.name }}</td>
                        <td class="td vs-table--td">
                            <vx-tooltip text="Download" v-if="tr.path != ''">
                                <vs-button type="line" icon-pack="feather" @click.stop="downloadFileAwsS3(tr.path)"
                                    icon="icon-download" />
                            </vx-tooltip>
                        </td>
                        <td class="td vs-table--td">
                            <template>
                                <vx-tooltip text="Delete">
                                    <vs-button type="line" icon-pack="feather"
                                        v-if="(!data.id || data.status == 0 || data.status == 3) && hasException"
                                        @click.stop="handleDeleteAttachment(i, tr.id)" icon="icon-trash" />
                                </vx-tooltip>
                            </template>
                        </td>
                    </tr>
                </template>
            </table>
        </div>
        <vs-divider style="width: 100%; margin-left: 0%"></vs-divider>

        <vs-popup title="Preview" :active.sync="showAttachment" :fullscreen="true">
            <iframe v-if="showAttachment" :src="attachmentPath" style="width: 100%; height: 80dvh" />
        </vs-popup>

        <div class="vx-row my-4">
            <div class="vx-col flex items-center gap-2">
                <vs-button v-if="(!this.data.id || this.data.status == 0 || this.data.status == 3) && hasException"
                    @click="handleSubmitWithoutApproval" color="primary" icon-pack="feather" icon="icon-save">
                    Save</vs-button>
                <vs-button v-if="(!this.data.id || this.data.status == 0 || this.data.status == 3) && hasException"
                    @click="handleSubmitApproval" color="primary" icon-pack="feather" icon="icon-save">
                    Save & Send Approval</vs-button>
                <vs-button @click="onClickBack()" color="danger" icon-pack="feather" icon="icon-x">Cancel</vs-button>
            </div>
        </div>
    </vx-card>
</template>

<script>
import moment from "moment";

export default {
    data() {
        return {
            table: this.tableDefaultState(),
            total_value: 0,
            territory: null,
            driver: null,
            exception: null,
            summary: [],
            need_exception: false,
            id: null,
            data: {
                id: null,
                driver_id: null,
                exception_id: null,
                personal_id: null,
                personal_name: "",
                territory_id: null,
                date: null,
                file: [],
                fileUrl: '',
                notes: null,
                status: null,
                json_data: [],
                status_pod: null,
                status_cit: null,
                status_closing: null,
                shipment_number: null,
            },
            fileAttactment: {
                multiple: true,
                disabled: false,
                value: null,
                preview: null,
                accepted_types: ["jpg", "jpeg", "png", "pdf", "doc", "docx", "xls", "xlsx"],
                files: [],
            },
            history_notes: "",
            status: 0,
            showAttachment: false,
            attachmentPath: "",
            attachment_ids: [],
            fileShow: false,
        };
    },
    mounted() {
        const routeData = this.$route.query.data;
        const routeDate = this.$route.query.date;
        const routeId = this.$route.query.id;

        if (routeId) {
            this.getData(routeId);
        } else {
            try {
                const parsedData = JSON.parse(routeData);
                this.applyData(parsedData, routeDate);
                // Save parsed object, not raw string
                localStorage.setItem("driver_page_data", JSON.stringify({
                    data: parsedData,
                    date: routeDate
                }));
            } catch (error) {
                console.log("masuk local", error);
                const saved = localStorage.getItem("driver_page_data");
                if (saved) {
                    const parsed = JSON.parse(saved);
                    // parsed.data is now already an object, no need to JSON.parse again
                    this.applyData(parsed.data, parsed.date);
                }
            }

            // always call getSummary after data is populated
            if (!this.data.id) {
                this.$nextTick(() => {
                    if (this.data.driver_id && this.data.date) {
                        this.getSummary();
                    }
                })
            }

            // if (this.data.id) {
            //     this.getData(this.data.id);
            // } else {
            //     this.getSummary();
            // }
        }
    },
    beforeRouteLeave(to, from, next) {
        localStorage.removeItem("driver_page_data");
        next();
    },
    methods: {
        applyData(data, date) {
            this.driver = data.personal.name;
            this.data.personal_id = data.personal.id;
            this.data.personal_name = data.personal.name;
            this.data.territory_id = data.WarehouseID;
            this.data.date = date;
            this.data.driver_id = data.id;
            this.data.id = data.exception[0] ? data.exception[0].id : null;
            this.exception = data.exception[0] ? data.exception[0].code : null;
            this.data.status_pod = data.detail.pod_status;
            this.data.status_cit = data.detail.cit_status;
            this.data.status_closing = data.detail.status_closing;
            this.data.shipment_number = data.detail.shipment_number;

            if (this.data.id) {
                this.getData(this.data.id);
            }
        },
        tableDefaultState() {
            return {
                data: [],
            };
        },
        onClickBack() {
            this.$router.go(-1);
        },
        needException(item) {
            if ((item.pod_code == '' || item.pod_code == null) ||
                (item.is_cod == 1 && (item.so_total != 0 && item.so_total != null) && (item.billing_total < item.so_total))) {
                return 'Yes';
            }
            return 'No';
        },
        getSummary() {
            this.$vs.loading();
            this.$http
                .get("/api/sfa/v1/daily-closing/driver/get-summary", {
                    params: {
                        driver_id: this.data.driver_id,
                        date: this.data.date,
                    },
                })
                .then((resp) => {
                    if (resp.code == 200) {
                        this.summary = resp.data;
                        this.data.json_data = {
                            summary: this.summary.map(item => ({
                                transport_plan_code: item.transport_plan_code,
                                do_code: item.do_code,
                                is_cod: item.is_cod,
                                pod_code: item.pod_code,
                                pi_total: item.pi_total,
                                so_total: item.so_total,
                                billing_total: item.billing_total,
                                cit_driver: item.cit_driver,
                                invoice_total: item.invoice_total,
                            }))
                        }
                    }
                    this.$vs.loading.close();
                })
                .catch((error) => {
                    this.$vs.loading.close();
                });
        },
        getData(id) {
            this.$vs.loading();
            this.$http
                .get("/api/sfa/v1/daily-closing/driver/get-exception", {
                    params: {
                        id: id,
                    },
                })
                .then((resp) => {
                    if (resp.code == 200) {
                        this.data.id = resp.data.id;
                        this.exception = resp.data.exception_code
                        this.driver = resp.data.personal_name
                        this.data.territory_id = resp.data.territory_id
                        this.data.driver_id = resp.data.personal_id
                        this.data.personal_id = resp.data.personal_id
                        this.data.personal_name = resp.data.personal_name
                        this.data.date = resp.data.date
                        this.history_notes = resp.data.notes.toString().split(";")
                        // this.summary = resp.data.summary.summary;
                        // this.data.json_data = resp.data.summary;
                        this.data.status = resp.data.status;
                        resp.data.data_attachment.map((r, i) => {
                            this.data.file.push({
                                id: r.id,
                                name: r.name,
                                path: r.path,
                                doc_type: r.doc_type,
                            })
                        })
                    } else {
                        this.$vs.notify({
                            color: "danger",
                            title: "Error",
                            text: resp.message,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                        });
                    }
                    this.$vs.loading.close();
                })
                .catch((error) => {
                    console.log(error)
                    this.$vs.loading.close();
                })
                .finally(() => {
                    // call getSummary after getData finishes so driver_id and date are set
                    if (this.data.driver_id && this.data.date) {
                        this.getSummary();
                    }
                });
        },
        handleDeleteAttachment(index, id) {
            this.data.file = this.data.file.filter((item, i) => i != index);
            this.attachment_ids = this.attachment_ids.filter((attachmentId) => attachmentId != id);
            this.deleteFile(id);
        },
        handleAttachment() {
            if (this.$refs.file.files[0]) {
                let a = this.$refs.file.files
                for (let i = 0; i < a.length; i++) {
                    if (a[i].size <= 5000000) { // 5mb
                        this.uploadData(a[i]);
                    } else {
                        this.$vs.notify({
                            title: "Error",
                            text: a[i].name + " is greater than 5MB",
                            color: "danger",
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-check",
                        });
                    }
                }
                document.querySelector("#fileInput").value = "";
            } else {
                this.$vs.notify({
                    title: "Error",
                    text: "No file chosen.",
                    color: "danger",
                    position: "top-right",
                    iconPack: "feather",
                    icon: "icon-check",
                });
            }
        },
        paramUpload(file) {
            var form = new FormData();
            form.append("id", this.id);
            form.append("file", file);
            form.append("type", file.type);
            return form;
        },
        uploadData(file) {
            this.$vs.loading();
            this.$http
                .post("/api/sfa/v1/daily-closing/driver/upload-file", this.paramUpload(file), {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((resp) => {
                    this.$vs.loading.close();
                    console.log("RESP ATTACHMENT", resp)
                    if (resp.code == 200) {
                        const responseData = resp && resp.data ? resp.data : {};
                        const attachment = responseData.attachment || {};
                        const attachmentId = attachment.id;
                        const item = {
                            id: attachmentId,
                            name: attachment.NameFile || attachment.name || file.name,
                            path: attachment.PathFile || attachment.path || "",
                            doc_type: attachment.DocType || attachment.doc_type || file.type,
                        };

                        if (!this.data) {
                            this.$set(this, "data", { file: [] });
                        }
                        if (!this.data.file) {
                            this.$set(this.data, "file", []);
                        }
                        this.$set(this.data.file, this.data.file.length, item);
                        if (attachmentId != null && !this.attachment_ids.includes(parseInt(attachmentId))) {
                            this.attachment_ids.push(parseInt(attachmentId));
                        }
                        this.$nextTick(() => {
                            this.data.file = [...this.data.file];
                        });
                        this.$vs.notify({
                            color: "success",
                            title: "Success",
                            text: resp.message,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                        });
                    } else {
                        this.$vs.notify({
                            color: "danger",
                            title: "Error",
                            text: resp.message,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                        });
                    }
                })
                .catch((error) => {
                    console.log(error)
                    this.$vs.loading.close();
                });
        },
        deleteFile(id) {
            this.$vs.loading();
            var form = new FormData();
            form.append("id", id);
            this.$http
                .post("/api/sfa/v1/daily-closing/driver/delete-file", form, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((resp) => {
                    this.$vs.loading.close();
                    if (resp.code == 200) {
                        this.$vs.notify({
                            color: "success",
                            title: "Success",
                            text: resp.message,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                        });
                    } else {
                        this.$vs.notify({
                            color: "danger",
                            title: "Error",
                            text: resp.message,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                        });
                    }
                })
                .catch((error) => {
                    console.log(error)
                    this.$vs.loading.close();
                });
        },
        paramData() {
            this.data.json_data = {
                ...this.data.json_data,
                status_pod: this.data.status_pod,
                status_cit: this.data.status_cit,
                status_closing: this.data.status_closing,
                shipment_number: this.data.shipment_number,
            };
            return {
                id: this.data.id,
                driver_id: this.data.driver_id,
                territory_id: parseInt(this.data.territory_id),
                personal_id: parseInt(this.data.driver_id),
                personal_name: this.data.personal_name,
                date: this.data.date,
                status: this.status,
                notes: this.data.notes,
                attachment_ids: this.attachment_ids,
                json_data: this.data.json_data
            };
        },
        postData() {
            this.$vs.loading();
            var url = this.data.id ? "/api/sfa/v1/daily-closing/driver/update" : "/api/sfa/v1/daily-closing/driver/create";
            this.$http
                .post(url, this.paramData())
                .then((resp) => {
                    if (resp.code == 200) {
                        this.$vs.loading.close();
                        this.$vs.notify({
                            color: "success",
                            title: "Success",
                            text: resp.message,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                        });
                        this.onClickBack();
                    } else {
                        this.$vs.loading.close();
                        this.$vs.notify({
                            color: "danger",
                            title: "Error",
                            text: resp.message,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                        });
                    }
                })
                .catch((error) => {
                    console.log(error)
                    this.$vs.loading.close();
                });
        },
        handleSubmitWithoutApproval() {
            this.$vs.dialog({
                type: "confirm",
                color: "primary",
                title: `Confirm`,
                text: "Please confirm to create document",
                accept: () => {
                    this.handleSubmit();
                },
            });
        },
        handleSubmit(sendApproval = false) {
            console.log("ID", this.id)
            if (sendApproval == true) {
                this.status = 1;
            }

            this.postData();
            // this.postData();
        },
        handleSubmitApproval() {
            this.$vs.dialog({
                type: "confirm",
                color: "primary",
                title: `Confirm`,
                text: "Please confirm to create & send to approval",
                accept: () => {
                    this.handleSubmit(true);
                },
            });
        },
        formatNumber(value) {
            if (value == 0 || value == null) {
                return "0"
            }
            return new Intl.NumberFormat("en-US", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }).format(value);
        },
        formatDate(value) {
            if (value) {
                return moment(String(value)).format("YYYY-MM-DD");
            }
        },
        stsExcText(sts) {
            if (sts == 0) {
                return "Open";
            } else if (sts == 1) {
                return "Waiting for Approval";
            } else if (sts == 2) {
                return "Approved";
            } else if (sts == 3) {
                return "Rejected";
            }
            return "";
        }
    },
    filters: {
        formatDate(value) {
            if (value) {
                return moment(String(value)).format("DD-MM-YYYY");
            }
        },
    },
    computed: {
        groupedSummary() {
            return this.summary.reduce((groups, item) => {
                const key = item.transport_plan_code
                if (!groups[key]) {
                    groups[key] = []
                }
                groups[key].push(item)
                return groups
            }, {})
        },
        hasException() {
            return Object.values(this.groupedSummary).some(group => {
                if (group[0].closing_status === 'Not Yet') {
                    return true
                }
                return false
                // return group.some(item => this.needException(item) === 'Yes')
            })
        }
    }
};
</script>

<style scoped>
.tabular-nums {
    font-variant-numeric: tabular-nums;
}

.vs-table {
    border-collapse: collapse;
    width: 100%;
}

.vs-table th,
.vs-table td {
    border: 1px solid #404040;
    padding: 6px 10px;
}
</style>
